import { MembershipInfo } from '@wellesley/openapi'

const getRoles = (membership?: MembershipInfo): string[] =>
  (membership?.member?.roles as string[]) ?? []

const hasRole = (role: string, membership?: MembershipInfo) =>
  getRoles(membership).some((r) => r.toUpperCase() === role.toUpperCase())

//TODO: discuss rbac permissions for owner
export const isOwner = (membership?: MembershipInfo) =>
  hasRole('OWNER', membership)
